
<div class="irb-select-multiple-portfolios-dialog">
  <div mat-dialog-title>Add Multiple Portfolios to this Rebalance</div>
  <mat-dialog-content>
    @if (!isUiTest) {
      <irb-inventory-grid id="irb-select-multiple-portfolios-dialog"
        style ="height: 450px"
        [showSideBar] ='false'
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        [style.minHeight]="'450px'"
        [frameworkComponents]='frameworkComponents'
        [footerContent] = "footerContent"
        [componentName] = "'SelectMultiplePortfoliosDialog'"
      ></irb-inventory-grid>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="closeDialog()" class="btn-medium-secondary">Cancel</button>
    <button id="addSelectedSecButton" (click)="addMultiplePortfolios()"
      [disabled]="disableAddBtn"
    class="btn-medium-primary">Add Selected Portfolios to this Rebalance</button>
  </mat-dialog-actions>
</div>

<ng-template #noOptionsTemplate >
  <div style='margin-bottom: 10px !important;'>No labels created. Create custom portfolio<br/>labels in iRebal settings.</div><a (click)='pls.openGlobalSettings()'>Go to Settings</a>
</ng-template>